import React, { Component } from "react";
import ReactDOM from "react-dom";
import Base from "./Base";

export default class PriceBase extends Base {
	constructor(props) {
		super(props);
		this.state = {};

		this.hasPrice = this.props.hasPrice;
		this.hasMonthlyPrice = this.props.hasMonthlyPrice;
		this.hasPointsPrice = this.props.hasPointsPrice;
	}

	getPriceCurrency(number) {
		const price = this.getPriceDecimal(number);
		return price.charAt(0) == "-"
			? `-€${price.substring(1, price.length)}`
			: `€${price}`;
	}

	getPriceDecimal(number) {
		return this.truncateDecimal(number, 2)
			.toString()
			.replace(".", ",");
	}

	truncateDecimal(number, digits) {
		return parseFloat(Math.round(number * 100) / 100).toFixed(digits);
	}

	hasNumber(number) {
		return number != null && number != 0;
	}
}
